export const BASE_URL = 'https://jobicy.com/api/v2/remote-jobs';
